<template>
  <div style="width:100vw;height:100vh" class="flex-block-center">
    <logoSVG style="width:250px"></logoSVG>
    <div v-if="authLoaded && !user" style="margin:30px">Login to myHive</div>
    <v-btn
      v-if="authLoaded && !user"
      color="purple"
      large
      @click="googleLogin()"
      >Google Login</v-btn
    >
    <div class="flex-block-center" v-else style="height: 10vh">
      <v-progress-circular indeterminate color="primary"></v-progress-circular>
    </div>

    <sloganSVG style="width:30vh;max-width:350px;margin:50px"></sloganSVG>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import firebase from "firebase";
import logoSVG from "../hive/logoSVG";
import sloganSVG from "../hive/sloganSVG";

export default {
  name: "Login",
  components: {
    logoSVG,
    sloganSVG
  },
  computed: {
    ...mapGetters({
      authLoaded: "user/getAuthLoaded",
      user: "user/getUser"
    })
  },
  methods: {
    ...mapActions("user", { updateUser: "updateUser" }),
    googleLogin() {
      const provider = new firebase.auth.GoogleAuthProvider();
      firebase.auth().setPersistence(firebase.auth.Auth.Persistence.LOCAL);
      firebase
        .auth()
        .signInWithPopup(provider)
        .then(async result => {
          if (result) {
            console.log("result=", result);
            this.updateUser(result.user);
            localStorage.setItem("login", true);
            localStorage.setItem("token", result.credential.accessToken);
          }
        })
        .catch(error => {
          console.log(error);
        });
    }
  }
};
</script>
